let websocket = { isOpen: () => false }

export const setSocket = socket => {
  websocket = socket
}

export const getSocket = () => websocket
